<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="section-alamo-b2b container-xl py-5">
        <div class="row align-items-center">
            <!-- Columna izquierda: texto -->
            <div class="col-12 col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
                <h2 class="b2b-title">
                    <span class="text-blue">{{
                        'fe_lp_alamo_lease_title_1' | translate
                    }}</span
                    ><br />
                    <span class="highlight">{{
                        'fe_lp_alamo_lease_title_2' | translate
                    }}</span>
                </h2>
                <p class="b2b-subtitle">
                    <span class="text-blue">{{
                        'fe_lp_alamo_lease_subtitle_1' | translate
                    }}</span
                    >,
                    <span class="highlight">{{
                        'fe_lp_alamo_lease_subtitle_2' | translate
                    }}</span>
                </p>
                <a
                    [routerLink]="[]"
                    fragment="sectionForm"
                    class="btn btn-unete fw-bold px-4 py-2 mt-3"
                >
                    {{ 'fe_lp_alamo_lease_cta_join' | translate }}
                </a>
            </div>

            <!-- Columna derecha: imagen -->
            <div class="col-12 col-lg-6 text-center">
                <img
                    [src]="'images/alamo-b2b-equipo.jpg' | cdn"
                    alt="Alamo B2B equipo"
                    class="img-fluid b2b-img rounded-4"
                />
            </div>
        </div>
    </section>

    <section class="section-alamo-beneficios py-5">
        <div class="container-xl">
            <div class="row justify-content-center align-items-start gx-5 gy-5">
                <div class="col-12 col-lg-4 text-center">
                    <img
                        [src]="'images/icono-llaves.svg' | cdn"
                        alt="Ícono llaves"
                        class="img-fluid mb-4 icon-img"
                    />
                </div>

                <div class="col-12 col-lg-6">
                    <div class="benefit-box p-4 mb-4">
                        <p class="benefit-text mb-0">
                            {{ 'fe_lp_alamo_lease_benefit_1' | translate }}
                            <strong class="text-highlight">
                                {{
                                    'fe_lp_alamo_lease_benefit_1_strong'
                                        | translate
                                }}
                            </strong>
                        </p>
                    </div>
                </div>
            </div>

            <div
                class="row justify-content-center align-items-start gx-5 gy-5 mt-md-4"
            >
                <div class="col-12 col-lg-6">
                    <div class="benefit-box p-4">
                        <p class="benefit-text">
                            {{ 'fe_lp_alamo_lease_benefit_2' | translate }}
                            <strong class="text-highlight">
                                {{
                                    'fe_lp_alamo_lease_benefit_2_strong'
                                        | translate
                                }}
                            </strong>
                        </p>
                        <a
                            [routerLink]="[]"
                            fragment="sectionForm"
                            class="btn btn-unete fw-bold px-4 py-2 mt-3"
                        >
                            {{ 'fe_lp_alamo_lease_cta_join' | translate }}
                        </a>
                    </div>
                </div>

                <div class="col-12 col-lg-4 text-center">
                    <img
                        [src]="'images/icono-app.svg' | cdn"
                        alt="Ícono celular"
                        class="img-fluid icon-img d-none d-md-block"
                    />
                </div>
            </div>
        </div>
    </section>

    <section class="section-comparativa py-5">
        <div class="container-xl">
            <h2 class="comparativa-title text-center mb-5">
                {{ 'fe_lp_alamo_lease_comparison_title' | translate }}
            </h2>

            <div class="table-responsive">
                <div
                    class="comparison-table d-flex flex-row-reverse flex-md-column flex-lg-row rounded-4 overflow-hidden"
                >
                    <!-- Columna: Características -->
                    <div class="col-caracteristicas p-4 d-none d-md-block">
                        <div class="cell-title">
                            {{ 'fe_lp_alamo_lease_feature_title' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_1' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_2' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_3' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_4' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_5' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_6' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_7' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_feature_8' | translate }}
                        </div>
                    </div>

                    <!-- Columna: Alamo B2B -->
                    <div class="col-alamo p-4 text-white">
                        <div class="cell-title">
                            {{
                                'fe_lp_alamo_lease_alamo_col_title' | translate
                            }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_1' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_2' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_3' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_4' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_5' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_6' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_7' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_alamo_8' | translate }}
                        </div>
                    </div>

                    <!-- Columna: Competencia -->
                    <div class="col-competencia p-4">
                        <div class="cell-title">
                            {{
                                'fe_lp_alamo_lease_competencia_col_title'
                                    | translate
                            }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_1' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_2' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_3' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_4' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_5' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_6' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_7' | translate }}
                        </div>
                        <div class="cell">
                            {{ 'fe_lp_alamo_lease_comp_8' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section
        class="section-cta-final d-flex align-items-center text-star text-md-center text-white"
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h2 class="cta-text mb-4">
                        {{ 'fe_lp_alamo_lease_cta_final_text' | translate }}
                    </h2>
                    <a
                        [routerLink]="[]"
                        fragment="sectionForm"
                        class="btn btn-unete fw-bold px-4 py-2 mt-3"
                    >
                        {{ 'fe_lp_alamo_lease_cta_final_button' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </section>

    <section class="renta-form py-5 enterprises" id="sectionForm">
        <div class="container">
            <div class="row align-items-center">
                <!-- Columna Izquierda: Formulario -->
                <div class="col-lg-8">
                    <h2 class="renta-form__title">
                        {{ 'fe_enterprises_form_title_1' | translate }}
                        <span>{{
                            'fe_enterprises_form_title_2' | translate
                        }}</span>
                    </h2>
                    <p class="renta-form__subtitle">
                        {{ 'fe_hbspt_form_subtitle' | translate }}
                    </p>

                    <fe-app-form-enterprises></fe-app-form-enterprises>
                </div>

                <!-- Columna Derecha: Imagen -->
                <div class="col-lg-4 text-center mt-4 mt-lg-0">
                    <img
                        [src]="'images/carro-ilustracion.svg' | cdn"
                        alt="Formulario ilustración"
                        class="img-fluid"
                    />
                </div>
            </div>
        </div>
    </section>

    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
